export const SET_QUOTES = 'SET_QUOTES';
